module.exports = __webpack_public_path__ + "img/EMT.60905123.png";